import React from 'react';
import BarChart from './BarChart';
import { MONTHS } from '../constants';
import { cardStyle } from '../styles';

// entry: { budget, lastYear, result } with one value per month
const MonthlyBars = ({ entry, lastMonth, year }) => {
    const series = [
        { name: String(year - 1), color: '#e0892b', values: entry.lastYear },
        { name: `Budget ${year}`, color: '#9aa0a6', values: entry.budget },
        { name: `Utfall ${year}`, color: '#1779ba', values: entry.result.map((value, m) => (m <= lastMonth ? value : null)) },
    ];

    return (
        <div style={{ ...cardStyle, padding: '1rem' }}>
            <strong>F&ouml;rs&auml;ljning per m&aring;nad</strong>
            <BarChart categories={MONTHS} series={series} />
        </div>
    );
};

export default MonthlyBars;
